import { motion } from "framer-motion";
import React from "react";
import { useStateValue } from "../../context/StateProvider";
import { fadeInOut } from "../../utils/animations";

const Alert = () => {
  const [{ alertType }, dispatch] = useStateValue();

  return (
    <motion.div
      {...fadeInOut}
      className=" fixed top-12 left-0 p-4 w-screen flex flex-col items-end gap-2 z-50"
    >
      {alertType && alertType === "success" && (
        <div className="rounded-md px-4 py-2 bg-black shadow-md relative flex items-center justify-between gap-24">
          <div className="absolute -inset-0 bg-gray-500 -z-10 blur-sm"></div>
          <p className="text-xl text-green-500"> Data Added to the cloud</p>
        </div>
      )}

      {alertType && alertType === "successDelete" && (
        <div className="rounded-md px-4 py-2 bg-black shadow-md relative flex items-center justify-between gap-24">
          <div className="absolute -inset-0 bg-gray-500 -z-10 blur-sm"></div>
          <p className="text-xl text-green-500"> Data removed from the cloud</p>
        </div>
      )}

      {alertType && alertType === "info" && (
        <div className="rounded-md px-4 py-2 bg-black shadow-md relative flex items-center justify-between gap-24">
          <div className="absolute -inset-0 bg-gray-500 -z-10 blur-sm"></div>
          <p className="text-xl text-blue-500"> File Uploaded to the storage</p>
        </div>
      )}

      {alertType && alertType === "warning" && (
        <div className="rounded-md px-4 py-2 bg-black shadow-md relative flex items-center justify-between gap-24">
          <div className="absolute -inset-0 bg-gray-500 -z-10 blur-sm"></div>
          <p className="text-xl text-yellow-500">
            Warning : Please fill the required
          </p>
        </div>
      )}

      {alertType && alertType === "danger" && (
        <div className="rounded-md px-4 py-2 bg-black shadow-md relative flex items-center justify-between gap-24">
          <div className="absolute -inset-0 bg-gray-500 -z-10 blur-sm"></div>
          <p className="text-xl text-red-500">
            {" "}
            Something Wrong : Please try again !
          </p>
        </div>
      )}
    </motion.div>
  );
};

export default Alert;
